import { Text } from '@/components/text';
import { IconSymbol } from '@/components/ui/icon-symbol';

import { useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import Animated, {
  Extrapolation,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import HtmlView from './html-view';

interface FAQItemProps {
  question: string;
  answer: string;
  index: number;
}

export function FAQItem({ question, answer, index }: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const animatedValue = useSharedValue(0);

  const toggleOpen = () => {
    const newValue = isOpen ? 0 : 1;
    animatedValue.value = withTiming(newValue, { duration: 300 });
    setIsOpen(!isOpen);
  };

  const isEven = index % 2 === 0;

  // Since we don't know the exact height of the text, we'll use a more robust way for RN
  // for now, let's use layout animations or a measured approach.
  // Actually, for a simple accordion, we can use a simpler approach or a fixed max height.
  // Let's use layout animations which are easier for dynamic text height in RN.

  const iconStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          rotate: `${interpolate(animatedValue.value, [0, 1], [0, 180], Extrapolation.CLAMP)}deg`,
        },
      ],
    };
  });

  return (
    <View style={[styles.container, !isEven && { backgroundColor: 'transparent' }]}>
      <Pressable onPress={toggleOpen} style={({ pressed }) => [styles.pressable, { opacity: pressed ? 0.7 : 1 }]}>
        <View style={styles.header}>
          <Text className={`flex-1 pr-4 ${isOpen ? 'text-primary' : 'text-black'}`}>{question}</Text>
          <Animated.View style={iconStyle}>
            <IconSymbol name='chevron.down' size={20} color={isOpen ? '#0B5FFF' : '#666'} />
          </Animated.View>
        </View>
      </Pressable>

      {isOpen && (
        <View style={styles.content}>
          <HtmlView data={answer} />
          {/* <Text>{answer}</Text> */}
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    borderRadius: 10,
    backgroundColor: '#EAEAEA',
  },
  pressable: {
    width: '100%',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
  },
  content: {
    paddingHorizontal: 24,
    paddingLeft: 36,
    paddingBottom: 24,
  },
});
